module.exports = __webpack_public_path__ + "img/NO937902174.94a7cdde.png";